export const FavoritesSection = {
  title: 'Favorit',
  removeButtonTitle: 'Eliminar tot',
  more: 'Més',
  form: 'Formulari',
  formTitle:
    'Seleccioni els serveis que li interessen i ompli el formulari perquè puguem contactar amb vostè.',
};
